import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Spinner from '../../../components/layout/Spinner';
import { confirmEmail } from '../../../services/userService';

const ConfirmRegistration = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('Confirming your email address...');

  useEffect(() => {
    let isMounted = true;
    let redirectTimer;

    const completeConfirmation = async () => {
      const token = searchParams.get('token');

      if (!token) {
        if (isMounted) {
          setStatus('error');
          setMessage('This confirmation link is missing a token. Please use the latest email we sent you.');
        }
        return;
      }

      try {
        await confirmEmail(token);

        if (isMounted) {
          setStatus('success');
          setMessage('Your email has been confirmed. Redirecting you to login...');
          redirectTimer = setTimeout(() => {
            navigate('/login', { replace: true });
          }, 1500);
        }
      } catch (error) {
        if (isMounted) {
          setStatus('error');
          setMessage(
            error.response?.data?.error ||
              error.message ||
              'We could not confirm your email. Please try again from the latest confirmation email.'
          );
        }
      }
    };

    completeConfirmation();

    return () => {
      isMounted = false;
      if (redirectTimer) {
        clearTimeout(redirectTimer);
      }
    };
  }, [navigate, searchParams]);

  return (
    <div className="min-h-[calc(100vh-25vh)] opacity-0 animate-fadeInFast">
      <Helmet>
        <title>Confirm Email | CVHQ</title>
      </Helmet>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <a href="/">
            <img
              className="mx-auto h-12 w-auto"
              src="/CVHQ-Icon-Dark.svg"
              alt="Your Company"
            />
          </a>
          <h2 className="mt-8 text-center text-2xl font-bold leading-9 tracking-tight text-darkGrey">
            Confirm your email
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-200">
            <p className="text-sm leading-6 text-slateGrey">{message}</p>

            {status === 'pending' && (
              <div className="mt-8 flex justify-center">
                <Spinner />
              </div>
            )}

            {status === 'success' && (
              <div className="mt-8 rounded-lg bg-green-50 px-4 py-3 text-sm font-medium text-green-700">
                Your email has been confirmed.
              </div>
            )}

            {status === 'error' && (
              <div className="mt-8">
                <a
                  href="/login"
                  className="inline-flex rounded-md bg-primaryBlue px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lightBlue"
                >
                  Go to login
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmRegistration;


